var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDribbleSCurve(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-dribbles-arrow-s-curve_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-dribbles-arrow-s-curve_1",
    "data-name": "Icon-dribbles-arrow-s-curve \\u2013 1",
    clipPath: "url(#clip-Icon-dribbles-arrow-s-curve_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-dribbles-arrow-s-curve",
    transform: "translate(8788.9 -10662.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M3164.825-13416.628l1.908,3.5,2.442-2.507,2.567,2.109,1.506-3.1,3.806.991-2.1-5.017,4.076,1.7,2.853-2.413v3.809l3.261,1.671",
    transform: "translate(-11951.332 24087.918)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-play-arrow",
    "data-name": "Icon material-play-arrow",
    d: "M0,0,1.109,5.48,0,10.96,8.611,5.48Z",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, -8766.165, 10665.318)",
    fill: "#707070"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbleSCurve);
export default __webpack_public_path__ + "static/media/dribble-s-curve.29e3c2540e4215ac7e3097b81a62bc1f.svg";
export { ForwardRef as ReactComponent };